import React from 'react';

import PropTypes from 'prop-types';
import { Container, Inner, Sign } from './styles';

export default function Footer({ id }) {
  return (
    <Container id={id}>
      <Inner>
        <h2>
          Dúvidas? <span>Fale com a gente!</span>
        </h2>
        <div>
          <p>
            <b>Fundação São Paulo</b><small> – mantenedora da PUC-SP e do ASSUNÇÃO</small></p>                    
          <p><b>Núcleo de Parcerias e Captação de Recursos</b><small> – PPI</small></p>
          <p>Janaína Santos</p>          
               
          <p>
            <a href="mailto:parcerias@fundasp.org.br">parcerias@fundasp.org.br</a>
          </p>
        </div>
      </Inner>
      <Sign>2026 Design e Desenvolvimento DTI•NMD</Sign>
    </Container>
  );
}
Footer.propTypes = {
  id: PropTypes.string,
};
